import {ErrorInfo, FormObject} from './adobe-launch';
export abstract class FormAbstractClass {
    private _genericForm:FormObject;
    
    constructor(private genericForm:FormObject) {
        this._genericForm = genericForm;
    }
    abstract start(): FormObject;
    abstract update(): FormObject;
    abstract error(): ErrorInfo;
    abstract cancel(): FormObject;
    abstract complete(): FormObject;
    public getGenericForm = () => {
        return this._genericForm;
    };
}
